/* 
    This file is to prompt webpack to take in the minimum requirements for starting the application.
    Importing site starts the application via start() being called at the end of the file.

    CommonJS require() syntax is used since ES6 imports do not import stylesheets.
*/

// Provides $ as jquery in the console
window.jQuery = window.$ = $;

// Dependencies
import 'jquery';
import 'bootstrap';
import 'loaders.css';
import Promise from 'promise-polyfill';
import * as Keys from '../../keys/keys.json';
import * as Config from './config';
import * as Site from './site';

var googleMapsScript = document.createElement('script');
googleMapsScript.src = `https://maps.googleapis.com/maps/api/js?key=${Keys.googleMaps}&v=3.exp&libraries=${Config.googleMapsLibraries}`;
googleMapsScript.onload = () => {
    Site.start();
}

document.head.appendChild(googleMapsScript);

// Polyfill for browsers that don't support promises
if (!window.Promise) {
    window.Promise = Promise;
}

// Stylesheets
require('bootstrap/dist/css/bootstrap.min.css');
require('../css/imports.scss');


// WEBPACK FOOTER //
// ../D:/builds/ACES/Pharmacy Compass Production Support/PharmacyCompass2/Content/scripts/start.js